export default import.meta.ROLLDOWN_FILE_URL_j1UaaG23FXgRuzf$hfavtg